import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "5 11 5 5 11 5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "19 13 19 19 13 19", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "5", x2: "19", y1: "5", y2: "19", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MoveDiagonal2";
const MoveDiagonal2 = memo(themed(Icon));
export {
  MoveDiagonal2
};
//# sourceMappingURL=move-diagonal-2.js.map
